<nav class="langtabs__nav">
  <span *ngFor="let lang of langs; let i = index">
    <a [ngClass]="{'langtabs__link--active': i === activeLangIndex}"
       class="langtabs__link langtabs__link--inverted"
       (click)="switchTab(i)">
      {{ lang }}
    </a>
  </span>
</nav>
<div *ngFor="let lang of langs; let i = index"
     [ngClass]="{'langtabs__content--active': i === activeLangIndex}"
     class="langtabs__content langtabs__content--inverted"
     id="param-langtab-{{ lang }}">
  <div class="cols">
    <div class="cols__col">
      <table>
        <tr class="header-row">
          <th></th>
          <th>Název parametru</th>
          <th>Hodnota</th>
          <th></th>
        </tr>
        <tbody [dragula]="'parameters-' + lang"
               [(dragulaModel)]="valueCol1">
          <tr *ngIf="valueCol1.length === 0">
            <td colspan="4"></td>
          </tr>
          <tr *ngFor="let item of valueCol1; let i = index"
              class="row">
            <td>
              <div class="col--handle drag-handle"
                   title="Přetáhnutím změnit pořadí">
                <i class="ico-drag drag-handle"></i>
              </div>
            </td>
            <td class="col col--title">
              <input type="text"
                     value="{{ item['title_' + lang] }}"
                     (input)="updateCol1Title($event, lang, i)"
                     placeholder="Název parametru">
            </td>
            <td class="col col--value">
              <input type="text"
                     value="{{ item['value_' + lang] }}"
                     (input)="updateCol1Value($event, lang, i)"
                     placeholder="Hodnota">
            </td>
            <td>
              <a class="col--remove"
                 (click)="removeCol1(i)">
                <i class="ico-remove"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <a class="cta cta--green cta--ico-left"
         (click)="addRowCol1()">
        <span class="ico-plus"></span> Přidat parametr</a>
    </div>
    <div class="cols__col">
      <table>
        <tr class="header-row">
          <th></th>
          <th>Název parametru</th>
          <th>Hodnota</th>
          <th></th>
        </tr>
        <tbody [dragula]="'parameters-' + lang"
               [(dragulaModel)]="valueCol2">
          <tr *ngIf="valueCol2.length === 0">
            <td colspan="4"></td>
          </tr>
          <tr *ngFor="let item of valueCol2; let i = index"
              class="row">
            <td>
              <div class="col--handle drag-handle"
                   title="Přetáhnutím změnit pořadí">
                <i class="ico-drag drag-handle"></i>
              </div>
            </td>
            <td class="col col--title">
              <input type="text"
                     value="{{ item['title_' + lang] }}"
                     (input)="updateCol2Title($event, lang, i)"
                     placeholder="Název parametru">
            </td>
            <td class="col col--value">
              <input type="text"
                     value="{{ item['value_' + lang] }}"
                     (input)="updateCol2Value($event, lang, i)"
                     placeholder="Hodnota">
            </td>
            <td>
              <a class="col--remove"
                 (click)="removeCol2(i)">
                <i class="ico-remove"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <a class="cta cta--green cta--ico-left"
         (click)="addRowCol2()">
        <span class="ico-plus"></span> Přidat parametr</a>
    </div>
  </div>
</div>